import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'TK DJ Services | Premier DJ, Audio, and Lighting Services',
  description = 'Professional DJ, audio engineering, and lighting production services in the DMV area. Specializing in weddings, corporate events, nightclubs, and private parties.',
  image = '/IMG_8256.jpeg',
  url = '',
  canonical = ''
}) => {
  const siteUrl = 'https://tkdjservices.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : fullUrl;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;
  
  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="TK DJ Services" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={imageUrl} />

      {/* WhatsApp specific */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:alt" content="TK DJ Services - Professional DJ and Audio Services" />
      
      {/* Additional meta tags for better link previews */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#415e4e" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black" />
      <meta name="apple-mobile-web-app-title" content="TK DJ Services" />
      <link rel="apple-touch-icon" href="/images/favicon.png" />
      <link rel="icon" type="image/png" href="/images/favicon.png" />
      <link rel="shortcut icon" href="/images/favicon.png" />

      {/* Additional meta tags for messaging apps */}
      <meta name="format-detection" content="telephone=no" />
      <meta name="apple-touch-fullscreen" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="application-name" content="TK DJ Services" />
      <meta name="msapplication-TileColor" content="#415e4e" />
      <meta name="msapplication-config" content="/browserconfig.xml" />
    </Helmet>
  );
};

export default SEO; 